import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import bbox from '@turf/bbox';
import { feature, featureCollection } from '@turf/helpers';
import { selectors } from '../../store/dux/field-boundary-management-dux';
import { useContext } from './context';

export function useBounds() {
  const { tab, irrigationBoundaries, focusedFeature, selectedFeatures } =
    useContext();
  const isIrrigation = /IRRIGATION/i.test(tab);

  const allFields = useSelector(selectors.bounds);
  const focusedField = useSelector(selectors.focusedBounds);
  const selectedFields = useSelector(selectors.selectedBounds);

  const allIrrigation = useMemo(
    () => buildBoundingBox(irrigationBoundaries),
    [irrigationBoundaries],
  );

  const focusedIrrigation = useMemo(
    () =>
      focusedFeature
        ? buildBoundingBox(
            irrigationBoundaries.filter((b) => b.id === focusedFeature),
          )
        : null,
    [focusedFeature, irrigationBoundaries],
  );

  const selectedIrrigation = useMemo(
    () =>
      buildBoundingBox(
        irrigationBoundaries?.filter((b) => selectedFeatures.includes(b.id)),
      ),
    [irrigationBoundaries, selectedFeatures],
  );

  return [
    isIrrigation && focusedIrrigation,
    isIrrigation && selectedIrrigation,
    isIrrigation && allIrrigation,
    focusedField,
    selectedFields,
    allFields,
  ]
    .filter(Boolean)
    .at(0);
}

function buildBoundingBox(from) {
  if (from?.length) {
    const features = from.map((f) => f.shape && feature(f.shape));
    const boundaries = featureCollection(features.filter(Boolean));
    return bbox(boundaries);
  }
}
